// import React, { useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import useApiCallHooks from "../../../hooks/useApiCallHooks";
// import UIBody from "../../../components/ui/UIBody";

// const DetailsBlog = () => {
//   const { slug } = useParams();
//   const [responce, loading, error, callAPI] = useApiCallHooks();

//   useEffect(() => {
//     if (slug) {
//       callAPI("get", `get-blog-details/${slug}`);
//     }
//   }, [slug]);

//   const blog = responce?.data;

//   // Current blog URL for sharing
//   const blogUrl = window.location.href;

//   return (
//     <UIBody
//       loading={loading}
//       content={
//         <section className="py-5 bg-light">
//           <div className="container">
//             {blog ? (
//               <div className="row justify-content-center">
//                 <div className="col-lg-10">
//                   {/* Blog Title */}
//                   <h1 className="fw-bold mb-3">{blog.name}</h1>

//                   {/* Meta Info */}
//                   <div className="text-muted mb-3">
//                     <small>
//                       {blog.author && `By ${blog.author}`} •{" "}
//                       {blog.created_at &&
//                         new Date(blog.created_at).toDateString()}
//                     </small>
//                   </div>

//                   {/* Blog Image */}
//                   {blog.image && (
//                     <img
//                       src={blog.image}
//                       alt={blog.name}
//                       className="img-fluid rounded-3 shadow-sm mb-3"
//                       style={{
//                         maxHeight: "400px",
//                         objectFit: "cover",
//                         width: "100%",
//                       }}
//                     />
//                   )}

//                   {/* Blog Short Description (below image) */}
//                   {blog.description && (
//                     <div
//                       className="lead text-muted mb-4"
//                       dangerouslySetInnerHTML={{ __html: blog.description }}
//                     />
//                   )}

//                   {/* Blog Content */}
//                   <div
//                     className="blog-content"
//                     dangerouslySetInnerHTML={{ __html: blog.content }}
//                   />

//                   {/* Social Media Share */}
//                   <div className="mt-4">
//                     <h6 className="fw-bold mb-2">Share this blog:</h6>
//                     <div className="d-flex gap-2">
//                       <a
//                         href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
//                           blogUrl
//                         )}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="btn btn-sm btn-primary"
//                       >
//                         Facebook
//                       </a>
//                       <a
//                         href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
//                           blogUrl
//                         )}&text=${encodeURIComponent(blog.name)}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="btn btn-sm btn-info"
//                       >
//                         Twitter
//                       </a>
//                       <a
//                         href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
//                           blogUrl
//                         )}&title=${encodeURIComponent(blog.name)}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="btn btn-sm btn-secondary"
//                       >
//                         LinkedIn
//                       </a>
//                       <a
//                         href={`https://wa.me/?text=${encodeURIComponent(
//                           blog.name + " - " + blogUrl
//                         )}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="btn btn-sm btn-success"
//                       >
//                         WhatsApp
//                       </a>
//                     </div>
//                   </div>

//                   {/* Back to Blogs */}
//                   <div className="mt-5">
//                     <Link to="/blogs" className="btn btn-outline-primary">
//                       ← Back to Blogs
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               !loading && (
//                 <p className="text-center text-muted">Blog not found.</p>
//               )
//             )}
//           </div>
//         </section>
//       }
//     />
//   );
// };

// export default DetailsBlog;

import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import useApiCallHooks from "../../../hooks/useApiCallHooks";
import UIBody from "../../../components/ui/UIBody";
// Import Bootstrap Icons (make sure bootstrap-icons CSS is included in index.html or globally)
import "bootstrap-icons/font/bootstrap-icons.css";

const DetailsBlog = () => {
  const { slug } = useParams();
  const [responce, loading, error, callAPI] = useApiCallHooks();

  useEffect(() => {
    if (slug) {
      callAPI("get", `get-blog-details/${slug}`);
    }
  }, [slug]);

  const blog = responce?.data;

  // Current blog URL for sharing
  const blogUrl = window.location.href;

  return (
    <UIBody
      loading={loading}
      content={
        <section className="py-5 bg-light">
          <div className="container">
            {blog ? (
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  {/* Blog Title */}
                  <h1 className="fw-bold mb-3">{blog.name}</h1>

                  {/* Meta Info */}
                  <div className="text-muted mb-3">
                    <small>
                      {blog.author && `By ${blog.author}`} •{" "}
                      {blog.created_at &&
                        new Date(blog.created_at).toDateString()}
                    </small>
                  </div>

                  {/* Blog Image */}
                  {blog.image && (
                    <img
                      src={blog.image}
                      alt={blog.name}
                      className="img-fluid rounded-3 shadow-sm mb-3"
                      style={{
                        maxHeight: "400px",
                        objectFit: "cover",
                        width: "100%",
                      }}
                    />
                  )}

                  {/* Blog Short Description */}
                  {blog.description && (
                    <div
                      className="lead text-muted mb-4"
                      dangerouslySetInnerHTML={{ __html: blog.description }}
                    />
                  )}

                  {/* Blog Content */}
                  <div
                    className="blog-content"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                  />

                  {/* Social Media Share */}
                  <div className="mt-4">
                    <h6 className="fw-bold mb-2">Share this blog:</h6>
                    <div className="d-flex gap-3">
                      <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                          blogUrl
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-primary d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-facebook"></i> 
                      </a>
                      <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                          blogUrl
                        )}&text=${encodeURIComponent(blog.name)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-info d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-twitter"></i> 
                      </a>
                      <a
                        href={`https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
                          blogUrl
                        )}&title=${encodeURIComponent(blog.name)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-secondary d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                      <a
                        href={`https://wa.me/?text=${encodeURIComponent(
                          blog.name + " - " + blogUrl
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-success d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-whatsapp"></i>
                      </a>
                    </div>
                  </div>

                  {/* Back to Blogs */}
                  <div className="mt-5">
                    <Link to="/blogs" className="btn btn-outline-primary">
                      ← Back to Blogs
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              !loading && (
                <p className="text-center text-muted">Blog not found.</p>
              )
            )}
          </div>
        </section>
      }
    />
  );
};

export default DetailsBlog;
